import controlErrorsComponent from './error/controlErrors.component';
import controlNotificationsComponent from './notification/controlNotifications.component';

const controlMessagesModule = angular.module('app.common.controlMessages', [])
	.component('controlErrors', controlErrorsComponent)
	.component('controlNotifications', controlNotificationsComponent)
	.name;

export default controlMessagesModule;
